import React from "react";
import { App, Modal, Button, Typography, Descriptions, Space } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const { Text } = Typography;

export interface CredentialsModalProps {
  open: boolean;
  credentials: {
    email: string;
    password: string;
    schoolName: string;
    classroomsCreated: number;
  } | null;
  onClose: () => void;
}

const CredentialsModal: React.FC<CredentialsModalProps> = ({
  open,
  credentials,
  onClose,
}) => {
  const { message } = App.useApp();

  const handleCopy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
      message.success("Copiado");
    } catch {
      message.error("No se pudo copiar");
    }
  };

  return (
    <Modal
      open={open}
      title="Credenciales del teacher demo"
      onCancel={onClose}
      footer={
        <Button onClick={onClose}>Cerrar</Button>
      }
      destroyOnClose
    >
      {credentials && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Escuela">
              {credentials.schoolName}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              <Text copyable={false}>{credentials.email}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Contraseña">
              <Text
                style={{ fontFamily: "monospace", letterSpacing: 1 }}
              >
                {credentials.password}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Classrooms creadas">
              {credentials.classroomsCreated}
            </Descriptions.Item>
          </Descriptions>

          <Space>
            <Button
              icon={<CopyOutlined />}
              onClick={() => handleCopy(credentials.email)}
            >
              Copiar email
            </Button>
            <Button
              icon={<CopyOutlined />}
              onClick={() => handleCopy(credentials.password)}
            >
              Copiar password
            </Button>
          </Space>
        </Space>
      )}
    </Modal>
  );
};

export default CredentialsModal;
